import { useEffect, useState } from 'react';
import { SectionWrapper } from '../../../../components/ui/SectionWrapper';
import { useLanguage } from '../../../../context/LanguageContext';
import { Volunteering } from '../../../../models/volunteering.interface';
import { volunteeringService } from '../../../../services/volunteering.service';

export function VolunteeringSection() {
    const { lang, t } = useLanguage();
    const [volunteering, setVolunteering] = useState<Volunteering[]>([]);

    useEffect(() => {
        setVolunteering(volunteeringService.getVolunteering());
    }, []);

    return (
        <SectionWrapper id="volunteering" title={t('section.volunteering')} alternate>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {volunteering.map(vol => (
                    <div key={vol.id} className="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm ring-1 ring-slate-900/5 dark:ring-slate-700/50">
                        <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center mb-4">
                            <i className="bi bi-heart-fill text-blue-600 dark:text-blue-400" />
                        </div>
                        <h3 className="font-semibold text-slate-900 dark:text-white text-sm">
                            {vol.role[lang]}
                        </h3>
                        <p className="text-sm text-blue-600 dark:text-blue-400 mt-1">
                            {vol.organization}
                        </p>
                        <p className="text-sm text-slate-600 dark:text-slate-300 mt-2">
                            {vol.description[lang]}
                        </p>
                        <p className="text-xs text-slate-400 dark:text-slate-500 mt-2 font-mono">
                            {vol.period[lang]}
                        </p>
                    </div>
                ))}
            </div>
        </SectionWrapper>
    );
}
